module.exports = __webpack_public_path__ + "img/zysj.7d7beb61.png";